module.exports = __webpack_public_path__ + "img/icon-card-view.936b7f46.svg";